import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { applyPageMeta, setRobots } from '@/lib/seo'

const LINKS = [
  { href: '/', label: 'Home' },
  { href: '/sports/football', label: 'Football match analysis' },
  { href: '/sports/basketball', label: 'Basketball stats from video' },
  { href: '/sports/padel', label: 'Padel match analysis' },
  { href: '/solutions/communities', label: 'Community organisers' },
  { href: '/solutions/academies', label: 'Academies and coaches' },
  { href: '/solutions/venues', label: 'Venues' },
  { href: '/book-demo', label: 'Book a demo' },
]

export default function NotFound() {
  useEffect(() => {
    const path = window.location.pathname || '/404'
    applyPageMeta({
      title: 'Page not found — Statbox',
      description: 'This page does not exist on Statbox.',
      path,
    })
    setRobots(false)
  }, [])

  return (
    <div className="min-h-screen bg-black text-white">
      <main className="mx-auto w-full max-w-[36rem] px-5 pt-24 pb-16">
        <h1 className="text-3xl font-extrabold tracking-tight">This page does not exist</h1>
        <p className="mt-3 text-base leading-relaxed text-white/80">
          The link may be out of date. These pages are on Statbox:
        </p>
        <ul className="mt-5 space-y-2">
          {LINKS.map((link) => (
            <li key={link.href}>
              <Link
                to={link.href}
                className="inline-flex min-h-11 items-center text-[#9be7f0] underline decoration-white/20 underline-offset-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#71cdd9] rounded-sm"
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </main>
    </div>
  )
}
